import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Inject,
  OnDestroy,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';

import { WindowRefService } from '@hdms/shared/util-core';

import { LeftCardComponentAbstract } from './left-card.component.abstract';

@Component({
  selector: 'shrd-uic-left-card',
  templateUrl: './left-card.component.html',
  styleUrls: ['./left-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'leftCard'
})
export class LeftCardComponent extends LeftCardComponentAbstract implements OnDestroy {
  @Output() backdropClicked = new EventEmitter<void>();

  @HostBinding('class.shrd-uic-left-card') readonly hostClass = true;
  @ViewChild('cardContainer', { static: true }) cardContainer: ElementRef<HTMLDivElement>;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly renderer: Renderer2,
    win: WindowRefService,
    cdr: ChangeDetectorRef
  ) {
    super(win, cdr);
  }

  ngOnDestroy() {
    this.removeBodyScrollBar();
  }

  override open() {
    super.open();
    this.addBodyScrollBar();
  }

  onBackdropClick() {
    this.close();
    this.backdropClicked.emit();
  }

  protected override onClosed() {
    super.onClosed();
    this.removeBodyScrollBar();
  }

  private addBodyScrollBar() {
    this.renderer.addClass(this.document.body, 'modal-open');
  }

  private removeBodyScrollBar() {
    this.renderer.removeClass(this.document.body, 'modal-open');
  }
}
